/* eslint no-underscore-dangle: ['error', { allow: [_dailyPoll, _formData, _submitStatus] }] */
import { EventEmitter } from 'events';
import assign from 'object-assign';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const CHANGE_EVENT = 'change';

let _dailyPoll = {};
let _formData = {};
let _submitStatus = null;

const DailyPollStore = assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
  * @param {function} callback
  */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
  * @param {function} callback
  */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  setDailyPoll(dailyPoll) {
    _dailyPoll = dailyPoll;
  },

  getDailyPoll() {
    return _dailyPoll;
  },

  /**
   * Set form data
   */
  setFormData(data) {
    _formData = data;
  },

  /**
   * @return {object}
   */
  getFormData() {
    return _formData;
  },

  getAllowSubmit() {
    if (Object.prototype.hasOwnProperty.call(_dailyPoll, 'id')
      && Object.prototype.hasOwnProperty.call(_formData, _dailyPoll.id)
    ) {
      if (typeof _formData[_dailyPoll.id] === 'string') {
        _formData[_dailyPoll.id] = _formData[_dailyPoll.id].trim();
      }
      if (_formData[_dailyPoll.id].length) {
        return true;
      }
    }

    return false;
  },

  setSubmitStatus(value) {
    _submitStatus = value;
  },

  getSubmitStatus() {
    return _submitStatus;
  },
});

DailyPollStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.DAILY_POLL_LOAD_SUCCESS: {
      if (action.poll) {
        DailyPollStore.setDailyPoll(action.poll);
        DailyPollStore.emitChange();
      }
      break;
    }
    case ActionTypes.DAILY_POLL_SUBMIT_SUCCESS: {
      DailyPollStore.setSubmitStatus('success');
      DailyPollStore.emitChange();
      break;
    }
    case ActionTypes.DAILY_POLL_SUBMIT_ERROR: {
      DailyPollStore.setSubmitStatus('error');
      DailyPollStore.emitChange();
      break;
    }
    default:
      // do nothing
  }
});

module.exports = DailyPollStore;
